export default __webpack_public_path__ + "static/media/76872b08f634c6efae1c24cacee34c95.jpg";